import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import ApiService from '../../../services/ApiService';

export const fetchAllOpenTickets = createAsyncThunk(
  'tickets/fetchAllOpenTickets',
  async () => {
    const ticketList = await ApiService.getAllOpenMaintenanceTickets();
    return ticketList.data;
  },
);

export const fetchAllClosedTickets = createAsyncThunk(
  'tickets/fetchAllClosedTickets',
  async () => {
    const ticketList = await ApiService.getAllClosedMaintenanceTickets();
    return ticketList.data;
  },
);

export const fetchAllTickets = createAsyncThunk(
  'tickets/fetchAllTickets',
  async () => {
    const ticketList = await ApiService.getAllMaintenanceTickets();
    return ticketList.data;
  },
);

const initalTableSettings = {
  ticketNumber: true,
  wagonNumber: true,
  plannedType: true,
  ticketStatus: true,
  businessUnit: true,
  lastAnomalyDate: true,
  wagonStatus: true,
  loadedStatus: true,
  priority: true,
  damageCodes: true,
  damagePlace: true,
  nextRevisionDate: true,
  siteConcerned: true,
  keeper: true,
  productType: true,
  origin: true,
  labelWagon: true,
  appliedLabel: true,
  assignedWorkshop: true,
  ticketCreator: true,
};

const initialUserPreferences = [
  {
    viewName: 'open tickets',
    ticketListFiltered: 'openTicketList',
    rowsFilters: [],
    sortConfig: [],
    filteredColumns: initalTableSettings,
  },
  {
    viewName: 'closed tickets',
    ticketListFiltered: 'closedTicketList',
    rowsFilters: [],
    sortConfig: [],
    filteredColumns: initalTableSettings,
  },
  {
    viewName: 'tickets',
    ticketListFiltered: 'allTicketList',
    rowsFilters: [],
    sortConfig: [],
    filteredColumns: initalTableSettings,
  },
];
export const TicketListSlice = createSlice({
  name: 'ticketList',
  initialState: {
    openTickets: [],
    closedTickets: [],
    allTickets: [],
    fetchingOpen: false,
    fetchingClosed: false,
    currentViewName: 'open tickets',
    userPreferences: initialUserPreferences,
  },
  reducers: {
    setCurrentViewName: (state, action) => {
      state.currentViewName = action.payload;
    },
    setFilteredColumns: (state, action) => {
      const userPreferenceSelected = state.userPreferences.find(
        (userPreference) => userPreference.viewName === action.payload.viewName,
      );
      userPreferenceSelected.filteredColumns = action.payload.filteredColumns;
    },
    setRowsFiltersForCurrentTicketList: (state, action) => {
      const userPreferenceSelected = state.userPreferences.find(
        (userPreference) =>
          userPreference.viewName === action.payload.currentTicketList,
      );
      const list = userPreferenceSelected.rowsFilters.filter(
        (item) => item.cell === action.payload.optionsPerCell.cell,
      );
      if (list.length > 0) {
        userPreferenceSelected.rowsFilters =
          userPreferenceSelected.rowsFilters.filter((item) => item !== list[0]);
      }
      userPreferenceSelected.rowsFilters.push(action.payload.optionsPerCell);
    },
    addNewUserPreference: (state, action) => {
      state.userPreferences.push(action.payload);
    },
    setUserPreferences: (state, action) => {
      if (action.payload.length > 0) {
        action.payload.forEach((userPreference) => {
          const isExistingView = (pref) =>
            pref.viewName === userPreference.viewName;
          const registeredUserPreferencerIndex =
            state.userPreferences.findIndex(isExistingView);
          const userPreferenceRegistered = state.userPreferences.find(
            (userPreferenceSaved) =>
              userPreferenceSaved.viewName === userPreference.viewName,
          );
          if (
            Object.entries(userPreference).length !== 0 &&
            userPreferenceRegistered === undefined
          ) {
            userPreference.sortConfig = [];
            state.userPreferences.push(userPreference);
          } else {
            userPreference.sortConfig =
              userPreferenceRegistered !== undefined
                ? userPreferenceRegistered.sortConfig
                : [];
            state.userPreferences[registeredUserPreferencerIndex] =
              userPreference;
          }
        });
      }
    },
    deleteUserPreference: (state, action) => {
      const newUserPreferences = state.userPreferences.filter(
        (userPreference) => userPreference.viewName !== action.payload,
      );
      state.userPreferences = newUserPreferences;
    },
    initializeUserPreferences: (state, action) => {
      state.userPreferences = [];
      state.userPreferences.push(...initialUserPreferences.map((pref) => pref));

      if (action.payload.length > 0) {
        action.payload.forEach((userPreference) => {
          const userPreferenceWithSorting = {
            ...userPreference,
            sortConfig: [],
          };
          state.userPreferences.push(userPreferenceWithSorting);
        });
      }
    },
    setSortConfig: (state, action) => {
      const userPreferenceRegisterd = state.userPreferences.find(
        (userPreferenceSaved) =>
          userPreferenceSaved.viewName === state.currentViewName,
      );
      userPreferenceRegisterd.sortConfig = action.payload;
    },
  },
  extraReducers: {
    [fetchAllOpenTickets.pending]: (state) => {
      if (state.openTickets.length === 0) {
        state.fetchingOpen = true;
      }
    },
    [fetchAllClosedTickets.pending]: (state) => {
      if (state.closedTickets.length === 0) {
        state.fetchingClosed = true;
      }
    },
    [fetchAllTickets.pending]: (state) => {
      if (state.allTickets.length === 0) {
        state.fetchingOpen = true;
      }
    },
    [fetchAllOpenTickets.rejected]: (state) => {
      state.fetchingOpen = false;
    },
    [fetchAllClosedTickets.rejected]: (state) => {
      state.fetchingClosed = false;
    },
    [fetchAllTickets.rejected]: (state) => {
      state.fetchingOpen = false;
    },
    [fetchAllOpenTickets.fulfilled]: (state, action) => {
      state.openTickets = [];
      Array.prototype.forEach.call(action.payload, (ticket) => {
        state.openTickets.push(ticket);
      });
      state.fetchingOpen = false;
    },
    [fetchAllClosedTickets.fulfilled]: (state, action) => {
      state.closedTickets = [];
      Array.prototype.forEach.call(action.payload, (ticket) => {
        state.closedTickets.push(ticket);
      });
      state.fetchingClosed = false;
    },
    [fetchAllTickets.fulfilled]: (state, action) => {
      state.allTickets = [];
      Array.prototype.forEach.call(action.payload, (ticket) => {
        state.allTickets.push(ticket);
      });
      state.fetchingOpen = false;
    },
  },
});

export const fetchingOpenState = (state) => state.ticketList.fetchingOpen;
export const fetchingClosedState = (state) => state.ticketList.fetchingClosed;
export const openTicketsState = (state) => state.ticketList.openTickets;
export const closedTicketsState = (state) => state.ticketList.closedTickets;
export const allTicketsState = (state) => state.ticketList.allTickets;
export const userPreferencesState = (state) => state.ticketList.userPreferences;
export const currentViewNameState = (state) => state.ticketList.currentViewName;

export const {
  setFilteredColumns,
  setRowsFiltersForTicketList,
  addNewUserPreference,
  setRowsFiltersForCurrentTicketList,
  setUserPreferences,
  setCurrentViewName,
  deleteUserPreference,
  initializeUserPreferences,
  setSortConfig,
} = TicketListSlice.actions;

export default TicketListSlice.reducer;
